import { useTLang } from 'intl/intl';

export function useTurnOffCustomizationListLang() {
  return {
    title: useTLang({ id: 'menuPage.turnOff.customList.title' }),
    action: {
      primaryBtn: useTLang({
        id: 'menuPage.turnOff.customList.action.primaryBtn',
      }),
      secondaryBtn: useTLang({
        id: 'menuPage.turnOff.customList.action.secondaryBtn',
      }),
    },
    preForm: {
      paragraph: useTLang({
        id: 'menuPage.turnOff.customList.preForm.paragraph',
      }),
    },
    form: {
      all: {
        title: useTLang({ id: 'menuPage.turnOff.customList.form.all.title' }),
      },
      option: {
        description: useTLang({
          id: 'menuPage.turnOff.customList.form.option.description',
        }),
      },
    },
  };
}
